{
  "title": "Control Weather",
  "source": "Player's Handbook",
  "levelAndSchool": "8th-level transmutation",
  "level": 8,
  "castingTime": "10 minutes",
  "range": "Self (5-mile radius)",
  "components": "V, S, M (burning incense and bits of earth and wood mixed in water)",
  "duration": "Concentration, Up to 8 hours",
  "description": [
    "You take control of the weather within 5 miles of you for the duration. You must be outdoors to cast this spell. Moving to a place where you don’t have a clear path to the sky ends the spell early.",
    "When you cast the spell, you change the current weather conditions, which are determined by the DM based on the climate and season. You can change precipitation, temperature, and wind. It takes 1d4 x 10 minutes for the new conditions to take effect. Once they do so, you can change the conditions again. When the spell ends, the weather gradually returns to normal.",
    "When you change the weather conditions, find a current condition on the following tables and change its stage by one, up or down. When changing the wind, you can change its direction.",
    "Precipitation",
    "Stage 1",
    "Clear",
    "Stage 2",
    "Light clouds",
    "Stage 3",
    "Overcast or ground fog",
    "Stage 4",
    "Rain, hail or snow",
    "Stage 5",
    "Torrential rain, driving hail or blizzard",
    "Temperature",
    "Stage 1",
    "Unbearable heat",
    "Stage 2",
    "Hot",
    "Stage 3",
    "Warm",
    "Stage 4",
    "Cool",
    "Stage 5",
    "Cold",
    "Stage 6",
    "Arctic cold",
    "Wind",
    "Stage 1",
    "Calm",
    "Stage 2",
    "Moderate wind",
    "Stage 3",
    "Strong wind",
    "Stage 4",
    "Gale",
    "Stage 5",
    "Storm"
  ],
  "spellLists": ["cleric", "druid", "wizard"]
}
